/**
 * 群公告页懒加载壳（14.28；GroupLogLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function GroupNoticeLazy({ groupId }: { groupId: number }) {
  const { mod } = useLazyModule(() => import('./GroupNoticePage'));
  if (mod === null) return <div data-testid="group-notice-loading-shell">加载中…</div>;
  return <mod.GroupNoticePage groupId={groupId} />;
}
